// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const throttle = <A extends any[], F extends (...args: A) => void>(fn: F, delay: number) => {
  let timeoutTimer: NodeJS.Timeout | null = null;

  return (...args: A) => {
    if (timeoutTimer === null) {
      fn(...args);

      timeoutTimer = setTimeout(() => {
        timeoutTimer = null;
      }, delay);
    }
  };
};
